import React from 'react';

function Bone({ className = '' }) {
  return <span className={`cashflow-skeleton-bone ${className}`.trim()} aria-hidden />;
}

export function CashflowListPageSkeleton({ rows = 5 }) {
  return (
    <div className="cashflow-page cashflow-page--group-list cashflow-page--skeleton" aria-busy="true" aria-label="Loading groups">
      <header className="cashflow-page-head cashflow-page-head--skeleton">
        <div className="cashflow-page-head-main">
          <Bone className="cashflow-skeleton-head-icon" />
          <div className="cashflow-skeleton-head-copy">
            <Bone className="cashflow-skeleton-line cashflow-skeleton-line--eyebrow" />
            <Bone className="cashflow-skeleton-line cashflow-skeleton-line--title" />
            <Bone className="cashflow-skeleton-line cashflow-skeleton-line--subtitle" />
            <Bone className="cashflow-skeleton-line cashflow-skeleton-line--subtitle cashflow-skeleton-line--short" />
          </div>
        </div>
        <Bone className="cashflow-skeleton-btn" />
      </header>

      <div className="cashflow-group-list cashflow-group-list--skeleton">
        {Array.from({ length: rows }, (_, i) => (
          <div key={i} className="cashflow-group-item cashflow-group-item--skeleton">
            <div className="cashflow-skeleton-group-copy">
              <Bone className="cashflow-skeleton-line cashflow-skeleton-line--group-name" />
              <Bone className="cashflow-skeleton-line cashflow-skeleton-line--group-meta" />
            </div>
            <Bone className="cashflow-skeleton-badge" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function CashflowGroupPageSkeleton() {
  return (
    <div
      className="cashflow-page cashflow-page--group-detail cashflow-page--skeleton"
      aria-busy="true"
      aria-label="Loading group"
    >
      <section className="cashflow-group-hero cashflow-group-hero--skeleton">
        <div className="cashflow-group-hero-cover cashflow-group-hero-cover--skeleton">
          <div className="cashflow-group-hero-cover-nav">
            <Bone className="cashflow-skeleton-back cashflow-skeleton-back--hero" />
          </div>
          <Bone className="cashflow-skeleton-cover-meta" />
        </div>

        <div className="cashflow-group-hero-body">
          <div className="cashflow-group-hero-top">
            <div className="cashflow-group-hero-identity">
              <Bone className="cashflow-skeleton-hero-avatar" />
              <div className="cashflow-group-hero-copy">
                <Bone className="cashflow-skeleton-line cashflow-skeleton-line--title" />
              </div>
            </div>
          </div>

          <div className="cashflow-group-hero-kpis">
            <div className="cashflow-grid-3 cashflow-skeleton-stats">
              {[1, 2, 3].map((i) => (
                <div key={i} className="cashflow-stat cashflow-stat--skeleton">
                  <Bone className="cashflow-skeleton-line cashflow-skeleton-line--stat-label" />
                  <Bone className="cashflow-skeleton-line cashflow-skeleton-line--stat-value" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="cashflow-tabs cashflow-tabs--nav cashflow-tabs--skeleton">
        {[1, 2, 3, 4, 5].map((i) => (
          <Bone key={i} className="cashflow-skeleton-tab" />
        ))}
      </div>

      <div className="cashflow-date-toolbar cashflow-date-toolbar--skeleton">
        <Bone className="cashflow-skeleton-line cashflow-skeleton-line--toolbar-title" />
        <div className="cashflow-date-toolbar-row">
          <div className="cashflow-tabs cashflow-tabs--inline cashflow-tabs--period cashflow-tabs--skeleton-inline">
            {[1, 2, 3, 4].map((i) => (
              <Bone key={i} className="cashflow-skeleton-tab cashflow-skeleton-tab--inline" />
            ))}
            <Bone className="cashflow-skeleton-tab cashflow-skeleton-tab--date" />
          </div>
        </div>
      </div>

      <div className="cashflow-charts-row">
        {[1, 2].map((i) => (
          <div key={i} className="cashflow-card cashflow-card--skeleton">
            <div className="cashflow-chart-card-head cashflow-chart-card-head--skeleton">
              <Bone className="cashflow-skeleton-line cashflow-skeleton-line--card-title" />
              <Bone className="cashflow-skeleton-chart-dropdown" />
            </div>
            <Bone className="cashflow-skeleton-line cashflow-skeleton-line--card-lead" />
            <Bone className="cashflow-skeleton-chart" />
          </div>
        ))}
      </div>

      <div className="cashflow-card cashflow-card--compact-table cashflow-card--skeleton">
        <Bone className="cashflow-skeleton-line cashflow-skeleton-line--card-title" />
        <Bone className="cashflow-skeleton-table" />
      </div>
    </div>
  );
}
